import React from 'react'
import { StyledUpLateCard } from './TWStaticUpLateCard.styled'

export const TWStaticUpLateCard = () => {
    const promo = require('./images/promo.png')

    return (
        <StyledUpLateCard>
            <img src={promo} alt="" role="presentation" />
        </StyledUpLateCard>
    )
}
